const readableDate = (date:string):string => {
    return date.replace("T", " ").slice(0, 16)
}

export default readableDate